import { css } from 'lit';

export default css`
  :host {
    display: block;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: calc(var(--base-gap) / 2);
    width: fit-content;
    transition: background-color 0.2s ease;
    cursor: pointer;
    border: none;

    border-radius: 40px;
    padding-inline: var(--base-gap);
    padding-block: calc(var(--base-gap) / 2);
    color: #272727;

    border: 2px solid hsl(from var(--surface-cta) h s l / 0.4);
    background-color: #ccebf2;

    &:is(:hover, :focus-visible) {
      background-color: var(--surface-cta--action);
    }
  }
`;
